import { useTheme } from '@mui/material';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import type { ReactNode } from 'react';

import { resourcesColors } from '../../../theme/tokens/resourcesColors';

export type EventListItemProps = {
  title: string;
  date: string | Date;
  endDate?: string | Date | null;
  end_date?: string | Date | null;
  allDay?: boolean | null;
  all_day?: boolean | null;
  subtitle?: ReactNode;
  providerName?: string | null;
  provider_name?: string | null;
  accentColor?: string;
  action?: ReactNode;
  onClick?: () => void;
  'data-testid'?: string;
};

export function useEventListItem(props: EventListItemProps) {
  const theme = useTheme();

  const defaultAccentColor =
    theme.palette.rendezVous?.main ??
    theme.palette.resourcesColors?.rendezVous?.main ??
    resourcesColors.rendezVous.main;

  const accentColor = props.accentColor ?? defaultAccentColor;

  const dateRaw = props.date;
  const dateObj = typeof dateRaw === 'string' ? new Date(dateRaw) : dateRaw;

  const isAllDay = Boolean(props.allDay ?? props.all_day);

  const monthAbbr = format(dateObj, 'MMM', { locale: fr }).toUpperCase().replace('.', '');
  const dayNumber = format(dateObj, 'd', { locale: fr });
  const formattedDate = format(dateObj, 'd MMM yyyy', { locale: fr });
  const timeText = isAllDay ? 'Journée entière' : format(dateObj, 'HH:mm');

  const providerName = props.providerName ?? props.provider_name ?? null;

  return {
    accentColor,
    monthAbbr,
    dayNumber,
    formattedDate,
    timeText,
    providerName,
  };
}
